import { Column } from "@ant-design/charts";

export default function ImportExportChart({ data = [], height = 150 }) {
  const chartData = data.flatMap((x) => [
    { period: String(x.period ?? x.date ?? ""), type: "Impor", value: Number(x.importValue ?? x.impor) || 0 },
    { period: String(x.period ?? x.date ?? ""), type: "Ekspor", value: Number(x.exportValue ?? x.ekspor) || 0 },
  ]);

  const maxVal = Math.max(0, ...chartData.map((d) => d.value));
  // skala dinamis: nilai API orde 0.02–0.3, jangan hardcode 1500
  const yMax = maxVal <= 0 ? 1 : Math.ceil(maxVal * 1.2 * 100) / 100;

  const config = {
    data: chartData,
    xField: "period",
    yField: "value",
    colorField: "type",
    group: true,
    scale: {
      color: {
        range: ["#287db8", "#31a765"],
      },
      y: {
        min: 0,
        max: yMax,
      },
    },
    axis: {
      x: {
        labelFontSize: 9,
        lineStroke: "#cbd5e1",
        tick: false,
      },
      y: {
        labelFontSize: 9,
        gridStroke: "#e8edf2",
      },
    },
    legend: {
      position: "top",
      direction: "row",
    },
    style: {
      maxWidth: 10,
    },
    height: height,
    autoFit: true,
  };

  return <Column {...config} />;
}
